module.exports = __webpack_public_path__ + "img/main-banner-mobile-1035.4a581582.jpg";